import React, { Component } from 'react'

export class GuestHome extends Component {
  render() {
    return (
      <div>GuestHome</div>
    )
  }
}

export default GuestHome